module.exports = __webpack_public_path__ + "img/icon-miniapp-qrcode.790b1ac6.jpg";